module.exports = __webpack_public_path__ + "static/media/TownHouse.1461f685.svg";